import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="terms-container container mt-5 p-4 shadow-sm bg-white rounded">
      <h2 className="mb-4 fw-bold">Terms of Service</h2>

      <h5 className="fw-semibold">AGREEMENT TO TERMS</h5>
      <p>
        These Terms of Service constitute a legally binding agreement made between you,
        whether personally or on behalf of an entity you and Space we, concerning your access
        to and use of the space.com website as well as any other media form, media channel,
        mobile website or mobile application related, linked, or otherwise connected thereto
        (collectively, the "Site").
      </p>
      <p>
        You agree that by accessing the Site, you have read, understood, and agree to be bound
        by all of these Terms of Service. If you do not agree with all of these Terms of Service,
        then you are expressly prohibited from using the Site and you must discontinue use
        immediately.
      </p>

      <h5 className="fw-semibold mt-4">USER REPRESENTATIONS</h5>
      <p>By using the Site, you represent and warrant that:</p>
      <ol className="terms-list">
        <li>All registration information you submit will be true, accurate, current, and complete;</li>
        <li>You will maintain the accuracy of such information and promptly update such registration information as necessary;</li>
        <li>You have the legal capacity and you agree to comply with these Terms of Service;</li>
        <li>Not a minor in the jurisdiction in which you reside</li>
        <li>You will not access the Site through automated or non-human means, whether through a bot, script, or otherwise;</li>
      </ol>
      <p>
        If you provide any information that is untrue, inaccurate, not current, or incomplete,
        we have the right to suspend or terminate your account and refuse any and all current
        or future use of the Site (or any portion thereof).
      </p>

<div className="mt-4 d-flex gap-2">
  <button className="btn-decline">Not, right now</button>
  <button className="btn-agree"><Link to={"/"} className='text-white text-decoration-none'>I agree with terms</Link></button>
</div>

    </div>
  );
};

export default TermsOfService;
